import { UtilService } from '$src/js/base/services/UtilService';
import { TranslationService } from '$src/js/base/services/TranslationService';
import { FocusTrapService } from '$js/base/services/FocusTrapService';
import { KeyPressService } from '$js/base/services/KeyPressService';
import { ScrollService } from '$js/base/services/ScrollService';
import { WindowResizeService } from '$js/base/services/WindowResizeService';
import { HeroCardsService } from '$js/base/services/HeroCardsService';
import { HamburgerService } from '$js/base/services/HamburgerService';
import { MarqueeService } from '$js/base/services/MarqueeService';
import { NavigationService } from '$js/base/services/NavigationService';
import { ErrorService } from '$js/base/services/ErrorService';

export default class BaseModule {
  private static instance: BaseModule | null = null;
  private _utils: UtilService | null = null;
  private _i18n: TranslationService | null = null;
  private _focusTrap: FocusTrapService | null = null;
  private _keypress: KeyPressService | null = null;
  private _scroll: ScrollService | null = null;
  private _windowResize: WindowResizeService | null = null;
  private _error: ErrorService | null = null;
  private _heroCards: HeroCardsService | null = null;
  private _hamburger: HamburgerService | null = null;
  private _marquee: MarqueeService | null = null;
  private _navigation: NavigationService | null = null;

  private bootModules = [
    'utils',
    'i18n',
    'focusTrap',
    'keypress',
    'scroll',
    'windowResize',
    'error',
    'heroCards',
    'hamburger',
    'marquee',
    'navigation',
  ] as const;

  static getInstance(): BaseModule {
    BaseModule.instance ??= new BaseModule();
    return BaseModule.instance;
  }

  get utils(): UtilService {
    this._utils ??= new UtilService();
    return this._utils;
  }

  get i18n(): TranslationService {
    this._i18n ??= new TranslationService();
    return this._i18n;
  }

  get focusTrap(): FocusTrapService {
    this._focusTrap ??= new FocusTrapService();
    return this._focusTrap;
  }

  get keypress(): KeyPressService {
    this._keypress ??= new KeyPressService();
    return this._keypress;
  }

  get windowResize(): WindowResizeService {
    this._windowResize ??= new WindowResizeService();
    return this._windowResize;
  }

  get scroll(): ScrollService {
    this._scroll ??= new ScrollService();
    return this._scroll;
  }

  get error(): ErrorService {
    this._error ??= new ErrorService();
    return this._error;
  }

  get heroCards(): HeroCardsService {
    this._heroCards ??= new HeroCardsService();
    return this._heroCards;
  }

  get hamburger(): HamburgerService {
    this._hamburger ??= new HamburgerService();
    return this._hamburger;
  }

  get marquee(): MarqueeService {
    this._marquee ??= new MarqueeService();
    return this._marquee;
  }

  get navigation(): NavigationService {
    this._navigation ??= new NavigationService();
    return this._navigation;
  }

  boot(): void {
    type ModuleKey = (typeof this.bootModules)[number];

    this.bootModules.forEach((module: ModuleKey) => {
      return this[module];
    });
  }
}
